const loading = {
  addEvent: function () {
    document.addEventListener(
      "keydown",
      this.keyboardEventHanlder.bind(this),
      true
    );
  },
  keyboardEventHanlder: function (event) {
    if (event.defaultPrevented) {
      return;
    }

    switch (event.key) {
      case "Esc":
      case "Escape":
        loading.close();
        break;
      default:
        return;
    }

    event.preventDefault();
  },
  show: function () {
    this.addEvent();

    document.getElementById("load").style.display = "block";
    document.getElementById("maskLayer").style.display = "block";
  },
  close: function () {
    document.getElementById("load").style.display = "none";
    document.getElementById("maskLayer").style.display = "none";
  },
};

export default loading;
